import React, { useEffect, useState } from "react";
import { graphql } from "gatsby";
import slugify from "slugify";
import Image from "../../components/Image";
import DispensaryLayout from "../../layouts/DispensaryLayout";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import PickUpAndDelivery from "@herb/components/PickupAndDelivery";
import DispensaryButtons from "@herb/components/DispensaryButtons";
import { useScrollPercentage } from "react-scroll-percentage";
import OpeningHours from "@herb/components/OpeningHours";
import { InView } from "react-intersection-observer";
import { Link } from "gatsby";
import SEO from "@herb/components/seo";
import JsonLd from "@herb/components/Schema/JsonLd";
import { deployUrl } from "@herb/utils";
import { stateLabelValues } from "@herb/utils/constants";
import useWindowDimensions from "../../utils/useWindowDimensions";
import SectionHeading from "@herb/components/SectionHeading";
import DispensaryRelatedLinkCard from "../../components/Cards/DispensaryRelatedLinkCard";
import DescriptionForArticlePage from "@herb/components/DescriptionForArticlePage";
import FAQAccordion from "../../components/FAQAccordion";
import "./index.css";
import { Helmet } from "react-helmet";
import { fallbackImages } from "../../utils/constants";
// import { scriptCreate } from "@herb/utils/scripts";
const isBrowser = typeof window !== "undefined";

//Branch for adding best dispensaries

const DispensaryArticle = ({ data, pageContext }) => {
  const {
    allWordpressWpDispensary: alldispensaries,
    allWordpressWpDispensaryCategory
  } = data;

  const {
    related_links: { related_links: all_related_links }
  } = pageContext;

  const parentCategoryName = pageContext.parentCategory?.wpParent?.node?.name;

  const stateCategoryAbbrivation = stateLabelValues.find(
    state => state.label === parentCategoryName
  );

  const categoryDispensaries =
    allWordpressWpDispensaryCategory.nodes[0]?.bestDispensaries
      ?.bestDispensaries;

  const categoryContent =
    allWordpressWpDispensaryCategory.nodes[0]?.bestDispensaries?.content || [];

  // Generate FAQ Schema dynamically from category content
  const faqItems = [];

  // Extract FAQ data from content
  if (categoryContent && categoryContent.length > 0) {
    categoryContent.forEach(item => {
      if (
        item.__typename ===
          "WordpressWpDispensaryCategory_Bestdispensaries_Content_Faq" &&
        item.faq &&
        Array.isArray(item.faq)
      ) {
        item.faq.forEach(faqItem => {
          if (faqItem.question && faqItem.answer) {
            faqItems.push({
              "@type": "Question",
              name: faqItem.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faqItem.answer.replace(/<[^>]*>/g, "") // Strip HTML tags from answer
              }
            });
          }
        });
      }
    });
  }

  // Only create FAQ schema if there are FAQ items
  const faqSchema =
    faqItems.length > 0
      ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqItems
        }
      : null;

  const dispensaries = alldispensaries.nodes;

  const mergeDispensaries = categoryDispensaries
    ? [...categoryDispensaries, ...dispensaries]
    : dispensaries;
  const uniqueDispensaries = Array.from(
    new Set(mergeDispensaries.map(a => a.id))
  ).map(id => {
    return mergeDispensaries.find(a => a.id === id);
  });

  const [isInView, setIsInView] = useState();
  const [isInViewHeading, setIsInViewHeading] = useState("");
  const [center, setCenter] = useState({
    lat: dispensaries
      ? dispensaries[0]?.content_dispensary?.dispensaryAddress?.latitude
      : 40.7128,
    lng: dispensaries
      ? dispensaries[0]?.content_dispensary?.dispensaryAddress?.longitude
      : 74.006
  });
  const [firstLoad, setFirstLoad] = useState(true);
  const [ref, percentageLocal, entry] = useScrollPercentage({
    /* Optional options */
    threshold: 1
  });

  const { width } = useWindowDimensions();
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: `${process.env.GATSBY_GOOGLE_MAP_API_KEY}`
  });
  const [map, setMap] = React.useState(null);

  const addressinView = (viewValue, heading, content_dispensary) => {
    const position = {
      lat: content_dispensary?.dispensaryAddress?.latitude,
      lng: content_dispensary?.dispensaryAddress?.longitude
    };

    setCenter(position);
    setIsInView(viewValue);
    setIsInViewHeading(slugify(heading));
  };

  const handleActiveMarker = (heading, index) => {
    if (isBrowser) {
      document.getElementById(slugify(heading)).scrollIntoView({
        behavior: "smooth"
      });
    }
  };

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    // map.fitBounds(bounds);
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  // useEffect(() => {
  //   scriptCreate();
  // }, []);

  return (
    <div>
      <DispensaryLayout page={"dispensaryListing"}>
        {/* <>
          <Helmet>
            <meta name="robots" content="noindex" />
          </Helmet>
        </> */}
        <SEO
          title={`Weed Dispensaries in ${pageContext.name}, ${stateCategoryAbbrivation?.value}`}
          description={`Find the best medical and recreational marijuana dispensaries in ${pageContext.name}, as well as CBD and other cannabis suppliers. `}
          url={`${pageContext.dispensaryPath}`}
          canonical={`${deployUrl}${pageContext.dispensaryPath}`}
          breadcrumbs={[]}
        />
        {faqSchema && <JsonLd data={faqSchema} />}

        <div className=" featuredDispensaryPageCity">
          <div ref={ref} className="dispensaryCityPage">
            <div className="dispensaryFeaturedContentDiv P-L-0">
              <div className="dispensaryPageBanner">
                <div className="articlePageContent">
                  <h1 className="articlePageH1">
                    {`Dispensaries in ${pageContext.name}`}
                  </h1>
                </div>
              </div>
              {uniqueDispensaries &&
                uniqueDispensaries?.map((dispensary, index) => {
                  const { featuredImage, slug, title } = dispensary;
                  const { content_dispensary } = dispensary;
                  const {
                    callDispensary,
                    pickupAndDelivery
                  } = content_dispensary;
                  const { pickup, delivery } = pickupAndDelivery;

                  var phoneNumber =
                    callDispensary != null
                      ? callDispensary?.match(/\d+/g)?.join("")
                      : "";
                  phoneNumber =
                    callDispensary != null ? Number(phoneNumber) : "";

                  return (
                    <>
                      <div key={index} className="dispensariesMainDiv">
                        <div>
                          <div className="dispensarylistingCardImage">
                            <Link to={`/dispensaries/${slug}/`}>
                              <InView
                                as="div"
                                threshold={1}
                                id={slugify(title)}
                                onChange={(inView, entry) =>
                                  addressinView(
                                    inView,
                                    title,
                                    content_dispensary
                                  )
                                }
                              >
                                <Image
                                  src={
                                    featuredImage
                                      ? featuredImage?.node?.sourceUrl
                                      : "https://herb-platform-images.imgix.net/wp-content/uploads/2023/01/12084032/dispensary-image.png"
                                  }
                                  imgixParams={{ fit: "contain" }}
                                  fallback={fallbackImages.square}
                                  alt={
                                    featuredImage
                                      ? featuredImage?.node?.altText
                                      : ""
                                  }
                                  width={1}
                                />
                              </InView>
                            </Link>
                          </div>

                          <Link to={`/dispensaries/${slug}/`}>
                            <div className="dispensaryriesHeading">{title}</div>
                          </Link>

                          {pickup || delivery ? (
                            <div className="listingPickupAndDelivery">
                              <PickUpAndDelivery item={dispensary} />
                            </div>
                          ) : (
                            <></>
                          )}
                          <div className="listingDispensaryButtons">
                            <DispensaryButtons item={dispensary} />
                          </div>
                          <div className="dispensaryCallButton">
                            <a
                              className="callDispensary"
                              href={`tel:${phoneNumber}`}
                            >
                              Call Dispensary
                            </a>
                          </div>
                          {title == "Puffin Dispensary" ||
                          title == "PUFFIN DISPENSARY" ||
                          title == "Indigo Dispensary" ||
                          title == "INDIGO DISPENSARY" ? (
                            <div className="addressAndPhone">
                              <p>Phone : {phoneNumber}</p>
                              <p>
                                Address :{" "}
                                {
                                  dispensary.content_dispensary
                                    .dispensaryAddress.streetAddress
                                }
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                          <div>
                            <OpeningHours
                              item={dispensary.content_dispensary}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
            </div>

            {uniqueDispensaries.length !== 0 && (
              <div className="dispensaryMap">
                <div className="googleMapSingleMarker">
                  {isLoaded ? (
                    firstLoad ? (
                      <>
                        <GoogleMap
                          mapContainerClassName="mapContainerClass"
                          center={center}
                          zoom={window.scrollY > 110 ? 14 : 8}
                          onLoad={onLoad}
                          onUnmount={onUnmount}
                          options={{
                            mapTypeControl: false,
                            fullscreenControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            scaleControl: false,
                            zoomControl: true
                          }}
                        >
                          <Marker
                            icon={`https://herb-platform-images.imgix.net/wp-content/uploads/2023/12/19130613/map-marker-svgrepo-com2.png?w=40`}
                            zoom={10}
                            position={center}
                            label={{
                              text: `${uniqueDispensaries.length}`,
                              color: "white"
                            }}
                            onClick={() => setFirstLoad(false)}
                          />
                        </GoogleMap>
                      </>
                    ) : (
                      <GoogleMap
                        mapContainerClassName="mapContainerClass"
                        center={center}
                        zoom={window.scrollY > 110 ? 14 : 8}
                        onLoad={onLoad}
                        onUnmount={onUnmount}
                        options={{
                          mapTypeControl: false,
                          fullscreenControl: false,
                          streetViewControl: false,
                          rotateControl: false,
                          scaleControl: false,
                          zoomControl: true
                        }}
                      >
                        {uniqueDispensaries &&
                          uniqueDispensaries?.map((dispensary, index) => {
                            const position = {
                              lat:
                                dispensary?.content_dispensary
                                  ?.dispensaryAddress?.latitude,
                              lng:
                                dispensary?.content_dispensary
                                  ?.dispensaryAddress?.longitude
                            };
                            const {
                              zoom
                            } = dispensary?.content_dispensary?.dispensaryAddress;

                            return (
                              <Marker
                                key={index}
                                position={position}
                                icon={
                                  width > 768
                                    ? window.scrollY > 110
                                      ? isInView &&
                                        slugify(dispensary.title) ===
                                          isInViewHeading
                                        ? "https://herb-platform-images.imgix.net/wp-content/uploads/2022/08/17111905/MapMarker.png"
                                        : "https://herb-platform-images.imgix.net/wp-content/uploads/2022/09/19093937/marker-gray-style.png"
                                      : "https://herb-platform-images.imgix.net/wp-content/uploads/2022/10/04083042/Group-65.png"
                                    : "https://herb-platform-images.imgix.net/wp-content/uploads/2022/10/04083042/Group-65.png"
                                }
                                onClick={() =>
                                  handleActiveMarker(dispensary.title, zoom)
                                }
                              />
                            );
                          })}
                      </GoogleMap>
                    )
                  ) : (
                    <></>
                  )}
                  <div className="dispensaryCountMain">
                    <p className="dispensaryCountHeading">Dispensaries</p>
                    <p className="dispensaryCount"> {dispensaries.length}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="dispensary-category-content">
            {categoryContent && categoryContent.length > 0 && (
              <>
                {categoryContent.map((item, index) => {
                  if (
                    item.__typename ===
                    "WordpressWpDispensaryCategory_Bestdispensaries_Content_Image"
                  )
                    return (
                      <div
                        className="ImageForArticle"
                        key={`${item.__typename}-${index}`}
                      >
                        {item.imageLink ? (
                          <a
                            href={item.imageLink}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Image
                              className="lazyload ArticleMainImage DispensaryCategoryContentImage"
                              fallback={fallbackImages.square}
                              src={item.image?.sourceUrl}
                              alt={item.image?.altText || pageContext.name}
                              width={600}
                              height={330}
                              imgixParams={{
                                fit: "clip",
                                auto: "format,compress"
                              }}
                            />
                          </a>
                        ) : (
                          <Image
                            className="lazyload ArticleMainImage DispensaryCategoryContentImage"
                            src={item.image?.sourceUrl}
                            fallback={fallbackImages.square}
                            alt={item.image?.altText || pageContext.name}
                            width={600}
                            height={330}
                            imgixParams={{
                              fit: "clip",
                              auto: "format,compress"
                            }}
                          />
                        )}
                        {item.image?.caption && (
                          <div className="articleImageCredits">
                            <div className="imageCourtesy">
                              {item.image.caption}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  else if (
                    item.__typename ===
                    "WordpressWpDispensaryCategory_Bestdispensaries_Content_Text"
                  )
                    return (
                      <DescriptionForArticlePage
                        item={item}
                        showSticker={false}
                        key={`${item.__typename}-${index}`}
                      />
                    );
                  else if (
                    item.__typename ===
                    "WordpressWpDispensaryCategory_Bestdispensaries_Content_Heading"
                  )
                    return (
                      <div key={`${item.__typename}-${index}`}>
                        {item.level === "level1" ? (
                          <div className="headingWithSticker">
                            <h1 className="articlePageH1">{item.text}</h1>
                            {item?.addSticker && (
                              <div className="headingStickerContainer">
                                <Image
                                  className="lazyload headingSticker"
                                  src={item?.sticker420?.sourceUrl}
                                  alt="Sticker"
                                  imgixParams={{
                                    fit: "clip"
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        ) : item.level === "level2" ? (
                          <div className="headingWithSticker">
                            <h2 className="articleSubHeadings">{item.text}</h2>
                            {item?.addSticker && (
                              <div className="headingStickerContainer">
                                <Image
                                  className="lazyload headingSticker"
                                  src={item?.sticker420?.sourceUrl}
                                  alt="Sticker"
                                  imgixParams={{
                                    fit: "clip"
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="headingWithSticker">
                            <h3 className="articleSubHeadingsH3">
                              {item.text}
                            </h3>
                            {item?.addSticker && (
                              <div className="headingStickerContainer">
                                <Image
                                  className="lazyload headingSticker"
                                  src={item?.sticker420?.sourceUrl}
                                  alt="Sticker"
                                  imgixParams={{
                                    fit: "clip"
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  else if (
                    item.__typename ===
                    "WordpressWpDispensaryCategory_Bestdispensaries_Content_Faq"
                  )
                    return (
                      <div
                        className="articles-faq"
                        key={`${item.__typename}-${index}`}
                      >
                        <h2 className="articleSubHeadings faqSectionHeading">
                          Frequently Asked Questions
                        </h2>
                        {item?.faq?.map((faqItem, faqIndex) => (
                          <FAQAccordion
                            key={faqIndex}
                            question={faqItem.question}
                            answer={faqItem.answer}
                          />
                        ))}
                      </div>
                    );
                })}
              </>
            )}
          </div>
          <div className="moreRelatedDispensaries">
            <SectionHeading heading="More Dispensaries In" />
            <div className="relatedLinksCards">
              {all_related_links?.map((link, index) => {
                return (
                  <DispensaryRelatedLinkCard
                    key={index}
                    item={link}
                    length={all_related_links.length}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </DispensaryLayout>
    </div>
  );
};

export default DispensaryArticle;

export const pageQuery = graphql`
  query CityDispensariesQuery($slug: String!) {
    allWordpressWpDispensary(
      filter: {
        dispensaryCategories: { nodes: { elemMatch: { slug: { eq: $slug } } } }
      }
      sort: { fields: title, order: ASC }
    ) {
      nodes {
        ...Dispensary
      }
    }
    allWordpressWpDispensaryCategory(filter: { slug: { eq: $slug } }) {
      nodes {
        bestDispensaries {
          bestDispensaries {
            ... on WordpressWpDispensary {
              ...Dispensary
            }
          }
          content {
            ... on WordpressWpDispensaryCategory_Bestdispensaries_Content_Heading {
              __typename
              fieldGroupName
              text
              level
              sticker420 {
                sourceUrl
              }
              addSticker
            }
            ... on WordpressWpDispensaryCategory_Bestdispensaries_Content_Image {
              __typename
              fieldGroupName
              imageLink
              image {
                sourceUrl
                altText
              }
            }
            ... on WordpressWpDispensaryCategory_Bestdispensaries_Content_Text {
              __typename
              fieldGroupName
              text
              addSticker
              sticker420 {
                sourceUrl
              }
            }
            ... on WordpressWpDispensaryCategory_Bestdispensaries_Content_Faq {
              __typename
              fieldGroupName
              faq {
                answer
                question
              }
            }
          }
        }
      }
    }
  }
`;
